var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2860 2860",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1430,0C640.92,0,0,640.89,0,1430s640.92,1430,1430,1430,1430-640.89,1430-1430S2219.08,0,1430,0ZM2210,1563.9h-646.06v646.1c0,74.11-59.86,133.9-133.94,133.9s-133.87-59.79-133.87-133.9v-646.1h-646.13c-74.08,0-133.87-59.79-133.87-133.9s59.79-133.9,133.87-133.9h646.13v-646.1c0-74.11,59.79-133.9,133.87-133.9s133.94,59.79,133.94,133.9v646.1h646.06c74.08,0,133.94,59.79,133.94,133.9s-59.86,133.9-133.94,133.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plusCircle.87a3341a3e12ed5536c5e32c64d02f12.svg";
export { ForwardRef as ReactComponent };